import { render, staticRenderFns } from "./DsioCloseFilters.vue?vue&type=template&id=35edcb39&"
import script from "./DsioCloseFilters.vue?vue&type=script&lang=js&"
export * from "./DsioCloseFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35edcb39')) {
      api.createRecord('35edcb39', component.options)
    } else {
      api.reload('35edcb39', component.options)
    }
    module.hot.accept("./DsioCloseFilters.vue?vue&type=template&id=35edcb39&", function () {
      api.rerender('35edcb39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioCloseFilters.vue"
export default component.exports